const apiPrefix = process.env.NEXT_PUBLIC_APP_NAME;

/**
 * @deprecated Use api proxy client instead
 *
 * This function is deprecated and will be removed in future releases.
 */
function getNextApiRoute(pathname: string) {
    return apiPrefix ? `/api/${apiPrefix}/${pathname}` : `/api/${pathname}`;
}

export { getNextApiRoute };
